import api from "./api";
export default class CallConfigAPI {
  get(inviteUUID) {
    return api.get(`call/getcallconfig/${inviteUUID}`);
  }
}
